import * as React from "react";
import { DEFAULT_THEME, ThemeContext, ThemeFactory } from "@skbkontur/react-ui";

import { CandyApiClient } from "../../../Common/CandyApiClient/CandyApiClient";
import { nativeBrowserFetch } from "../../../Common/HttpClient/FetchImplementation/NativeBrowserFetch";
import { CandyApiClientProvider } from "../../../Common/CandyApiClient/CandyApiClientContext";

import { FormsHelperApplication } from "./Components/App/FormsHelperApplication";

const api = new CandyApiClient(nativeBrowserFetch, "//localhost.testkontur.ru:9182", undefined, undefined);

const labGrotesqueTheme = ThemeFactory.create({ controlLineHeightSmall: "19px" }, DEFAULT_THEME);

export const RootApplication = () => (
    <ThemeContext.Provider value={labGrotesqueTheme}>
        <CandyApiClientProvider value={api}>
            <FormsHelperApplication />
        </CandyApiClientProvider>
    </ThemeContext.Provider>
);
